import classnames from 'classnames';
import { extendTailwindMerge } from 'tailwind-merge';
export const twMerge = extendTailwindMerge({
    prefix: 'tw-'
});
export const cn = (...args) => {
    return twMerge(classnames(args));
};
